/** English copy. Product display name: scrubbd (keys stay neutral). */
export const en = {
  appTitle: "scrubbd",
  tagline: "No data leaves this page",
  verifyHow: "How to verify",
  limitsLink: "How it works and limits",
  stepDeposit: "1. Drop",
  stepReview: "2. Review",
  stepDownload: "3. Download",
  dropHint: "Drop a .log / .txt / .json file",
  chooseFile: "Choose a file",
  orPaste: "or paste text",
  pastePlaceholder: "Paste logs here…",
  analyze: "Analyze",
  clear: "Clear",
  options: "Options",
  redactInternalIds: "Redact internal IDs (user_id, device_id…)",
  redactBusinessIds: "Redact business IDs (invoice_id, order_id…)",
  geoModeLabel: "GPS coordinates:",
  geoMask: "Mask",
  geoRound: "Round (~1 km)",
  ipStyleLabel: "IP aliases:",
  ipPreserveClass: "Keep private / public",
  ipLabel: "Labels [IP-01]",
  colon: ": ",
  summary: "Summary",
  mappings: "Detected values",
  preview: "Preview after processing",
  previewTruncated: (shown: number, total: number) =>
    `Preview limited to the first ${shown} of ${total} characters. The downloaded file is complete.`,
  keep: "Keep",
  replace: "Replace",
  downloadClean: "Cleaned file",
  downloadReport: "Report",
  controlOk: "Check: no original values left",
  controlWarn: (n: number) =>
    `Check: ${n} original value${n > 1 ? "s" : ""} still present in the output`,
  emptyState: "Drop or paste a file to get started.",
  formatLabel: "Format",
  uniqueLabel: "unique values",
  occurrenceLabel: "occurrences",
  keptHint: "kept",
  colDecision: "Decision",
  colType: "Type",
  colOrigin: "Original",
  colAlias: "Alias",
  noValues: "No values to replace yet.",
  limitsTitle: "How it works and limits",
  limitsBack: "← Back to the tool",
  limitsBody: [
    "All processing runs in your browser. After the page has loaded, no network request is made.",
    "To verify: open the Network tab in developer tools, then analyze a file. You can also use the page in airplane mode.",
    "The tool pseudonymises obvious values (IP addresses, emails, phones via fields, addresses, GPS…). It does not guarantee full anonymity or GDPR compliance. A human review is still required before sharing.",
    "Aliases belong to distinct families (personne-01, compte-01, hote-01, email-01@…, [TEL-01]…) to avoid false associations. By default a private IP stays private and a public IP becomes a documentation address (RFC 5737).",
    "Internal and business identifiers are listed but kept by default.",
  ],
};

export type Messages = typeof en;
